/**
 * API Configuration Utility
 * Provides environment-based API base URLs
 */

// Get the subscription/signup API base URL from environment
export const getSubscriptionBaseUrl = (): string => {
  const baseUrl = process.env.REACT_APP_API_SIGNUP || 'https://cse-stv-superapp-service.ludojoy.com';
  // Remove trailing slash to prevent double slashes in URLs
  return baseUrl.replace(/\/$/, '');
};

// Get main API base URL
export const getMainBaseUrl = (): string => {
  const baseUrl = process.env.REACT_APP_HOST_NAME || 'https://api.ludojoy.com';
  // Remove trailing slash to prevent double slashes in URLs
  return baseUrl.replace(/\/$/, '');
};

// Get environment info
export const getEnvironment = (): string => {
  return process.env.NODE_ENV || 'development';
};

// Log current configuration (useful for debugging)
export const logApiConfig = () => {
  console.log('API Configuration:', {
    environment: getEnvironment(),
    mainBaseUrl: getMainBaseUrl(),
    subscriptionBaseUrl: getSubscriptionBaseUrl()
  });
};

